var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"web-map"},[_c('div',{attrs:{"id":"clickToDraw"}},[_vm._v("Click to draw point.")]),_c('div',{attrs:{"id":"olMap"}})])
}]

export { render, staticRenderFns }